// eslint-disable-next-line import/no-extraneous-dependencies
import { EXPIRED_SECOND } from '../../constants/Cookie'
import { setCookieHelper } from '../../ultils/cookie'

export function handleToken(
  accessToken: any,
  idToken: any,
  refreshToken: any,
  email: any,
) {
  setCookieHelper('accessToken', accessToken, EXPIRED_SECOND)
  setCookieHelper('idToken', idToken, EXPIRED_SECOND)
  setCookieHelper('refreshToken', refreshToken, EXPIRED_SECOND)
  setCookieHelper('email', email, EXPIRED_SECOND)
}
